import Utils from "utils/utils";
import * as Communicator from "@ts3d-hoops/web-viewer";

export default class GeneralOperator extends Communicator.Operators
    .SelectionOperator {
    viewer: Communicator.IWebViewer;

    oldMiliSeccond = 0;

    currentMiliSeccond = 0;

    posStart: Communicator.Point2 | undefined;

    posCurrent: Communicator.Point2 | undefined;

    isMouseMove = false;

    constructor(viewer: Communicator.IWebViewer) {
        super(viewer, viewer.view, viewer.noteTextManager);
        this.viewer = viewer;
    }

    onDoubleClick(): Promise<void> {
        return new Promise<void>((resolve) => {
            resolve();
        });
    }

    onMouseDown(event: Communicator.Event.MouseInputEvent): void {
        this.posStart = event.getPosition().copy();
        this.isMouseMove = false;
    }

    onMouseMove(event: Communicator.Event.MouseInputEvent): void {
        if (this.posStart) {
            this.posCurrent = event.getPosition().copy();
            if (
                Utils.isRectangleEnoughLarge(
                    this.posStart.x,
                    this.posStart.y,
                    this.posCurrent.x,
                    this.posCurrent.y
                )
            ) {
                this.isMouseMove = true;
            }
        }
    }

    onMouseUp(event: Communicator.Event.MouseInputEvent): void {
        if (!event.getHandled()) {
            if (
                !this.isMouseMove &&
                event.getButton() === Communicator.Button.Middle
            ) {
                return;
            }
        }
    }
}
